export const TOKEN_CHANGED_EVENT = 'auth:token-changed';

export function emitTokenChanged() {
  window.dispatchEvent(new Event(TOKEN_CHANGED_EVENT));
}

export function onTokenChanged(handler: () => void) {
  window.addEventListener(TOKEN_CHANGED_EVENT, handler);
  return () => window.removeEventListener(TOKEN_CHANGED_EVENT, handler);
}
